import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
const faqs = [{
  q: '¿Necesito experiencia en manualidades?',
  a: 'No. El método está diseñado para que alguien sin ninguna experiencia en decoración pueda seguirlo. Si puedes atar un lazo y doblar papel de seda, puedes hacer esto.'
}, {
  q: '¿Qué pasa si en mi ciudad no hay alguna de las tiendas?',
  a: 'El método incluye alternativas. La mayoría de los productos de Dollar Tree y 5 Below también se encuentran en tiendas de $1 locales o en Amazon. Hobby Lobby tiene presencia en más de 900 ciudades en EE.UU. y Bath & Body Works en más de 1,700.'
}, {
  q: '¿Puedo hacerlo si tengo solo $30 para invertir?',
  a: "Absolutamente. Con $30 puedes armar 2 kits del Proyecto 3 'Glow & Go' y ganar hasta $74 de ganancia. Luego reinviertes y escalas."
}, {
  q: '¿Funciona si vivo fuera de Estados Unidos?',
  a: 'El concepto del Regalo de Alto Valor Percibido funciona en cualquier país. Las tiendas mencionadas son americanas, pero la estrategia de comprar en tiendas de bajo costo y elevar la presentación aplica universalmente. En Latinoamérica: equivalentes serían tiendas de $10 pesos, Miniso, Daiso o mercados locales.'
}, {
  q: '¿Cuánto tiempo tarda en descargarse el ebook?',
  a: 'Inmediatamente después de tu compra recibes el enlace de descarga en tu correo. Acceso instantáneo — en menos de 2 minutos ya estás leyendo.'
}, {
  q: '¿Y si compro y no me funciona?',
  a: 'Tienes 7 días de garantía. Si aplicas el método, armas al menos un kit y no logras venderlo, te devolvemos cada centavo. Sin preguntas. Sin drama.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-24 bg-cream-50" data-id="element-1">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div className="text-center mb-16" data-id="element-3">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-ink-900 mb-4" data-id="element-4">
            PREGUNTAS FRECUENTES
          </h2>
          <div className="w-16 h-1 bg-emerald-900 mx-auto" data-id="element-5"></div>
        </div>

        <div className="space-y-4" data-id="element-6">
          {faqs.map((faq, idx) => <div key={idx} className={`border rounded-xl overflow-hidden transition-colors duration-300 ${openIndex === idx ? 'border-emerald-900 bg-white shadow-md' : 'border-blush-200 bg-white/50 hover:bg-white'}`} data-id="element-7">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-8">
                <span className="font-bold text-lg text-ink-900 pr-8" data-id="element-9">
                  {faq.q}
                </span>
                <div className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-colors ${openIndex === idx ? 'bg-emerald-900 text-white' : 'bg-blush-100 text-emerald-900'}`} data-id="element-10">
                  {openIndex === idx ? <Minus className="w-5 h-5" data-id="element-11" /> : <Plus className="w-5 h-5" data-id="element-12" />}
                </div>
              </button>

              <AnimatePresence data-id="element-13">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-14">
                    <div className="p-6 pt-0 text-ink-800 leading-relaxed border-t border-blush-50 mt-2" data-id="element-15">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}